import { isDefinedArray, reduce } from "et3-type-guards";
import { memoize, orderBy } from "lodash";
import { computed, observable } from "mobx";

import { apiCallGetDataForMyAuditingEfficiencyTable } from "../../../api/auditor-api/api-call-get-my-auditing-efficiency-data";
import { apiCallGetDataForMyAuditingPerformanceTable } from "../../../api/auditor-api/api-call-get-my-auditing-performance-data";
import { getSpecificDateWithDays } from "../../../core/et3-date";
import { isDateRangeValid } from "../../../helpers/et3-date-helper";
import { TAuditPerformance } from "../../../Types";
import getCoreUIStore from "../../core/core-ui-store";
import getCorePersonalStore from "../../core/core-personal-store";

class MyAuditingPerformanceStore {
  fromDate = observable.box<Date>(
    getSpecificDateWithDays({
      daysSubtracted: 1,
      daysAdded: 0
    })
  );
  toDate = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );
  auditPerformance = observable.box<TAuditPerformance[]>([]);

  auditEfficiency = observable.box([]);

  auditPerformanceOrdered = computed(() => {
    const auditPerformanceOrdered = orderBy(
      this.auditPerformance.get(),
      ["auditName"],
      ["asc"]
    );
    return auditPerformanceOrdered;
  });

  //JC to be handled as type with server any should be removed
  getEfficiencyData = () => {
    const finalizedData = this.auditEfficiency.get().map((data) => {
      return {
        event_name: reduce(() => data[0], ""),
        supervised_events: reduce(() => data[1], "0"),
        my_minor_errors: reduce(() => data[2], "0"),
        my_major_errors: reduce(() => data[3], "0"),
        total_errors: reduce(() => data[4], "0")
      };
    });
    return finalizedData;
  };

  getData = async () => {
    if (
      !isDateRangeValid({
        fromDate: this.fromDate.get(),
        toDate: this.toDate.get(),
        isLimitedToOneMonth: true
      })
    ) {
      return;
    }
    await Promise.all([
      this.getAuditPerformanceData(),
      this.getAuditEfficiencyData()
    ]);
  };
  getAuditPerformanceData = async () => {
    this.auditPerformance.set([]);
    getCoreUIStore().setIsLoading("AUDITOR_MY_AUDITING_PERFORMANCE", true);
    const auditData = await apiCallGetDataForMyAuditingPerformanceTable({
      adminId: 26,
      fromDate: this.fromDate.get(),
      toDate: this.toDate.get()
    });

    const { data: audData, status: audStatus } = auditData;
    if (audStatus === "ERROR") {
      return;
    }
    const newAudData = audData.map((item) => {
      return {
        auditName: item.auditName,
        major: item.major,
        minor: item.minor,
        no_issue: item.no_issue,
        total: item.total
      };
    });
    this.auditPerformance.set(newAudData);
    getCoreUIStore().setIsLoading("AUDITOR_MY_AUDITING_PERFORMANCE", false);
  };
  getAuditEfficiencyData = async () => {
    const { data, status } = await apiCallGetDataForMyAuditingEfficiencyTable({
      adminId: reduce(() => getCorePersonalStore().user.get().id, 0),
      dateMin: this.fromDate.get(),
      dateMax: this.toDate.get()
    });

    if (status === "OK" && isDefinedArray(data)) {
      this.auditEfficiency.set(data);
    } else {
      this.auditEfficiency.set([]);
    }
  };
}

const getMyAuditingPerformanceStore = memoize(
  () => new MyAuditingPerformanceStore(),
  () => 1
);
export default getMyAuditingPerformanceStore;
